import "./Footer.css";

export default function Footer() {

  return (
    <div className="footer">      
      <div className="footer-center">
        <span className="footer-text">
          <a
            href="https://www.microsoft.com/en-us/privacy/data-privacy-notice"
            target="_blank"
            rel="noopener noreferrer"
          >
            Microsoft Global Data Protection Notice
          </a>
        </span>
      </div>
    </div>
  );
}
